var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shift-class.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-01790d28!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shift-class.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftClass.vue
// module id = 716
// module chunks = 1